import React, { useEffect } from "react";
import Card from "../components/card";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAccommodations,
  fetchEvents,
  fetchResturants,
  fetchAttractionsites,
  fetchMalls,
  fetchBuses,
} from "../app/dbSlice";
import { useNavigate } from "react-router-dom";
import "../css/card.css";
import fallbackImages from "../assets/images";


const CategoryCards = ({ activeTab }) => {
  const {
    accommodations = [],
    events = [],
    restaurants = [],
    attractionsites = [],
    malls = [],
    buses = [],
  } = useSelector((state) => state.db);

  const cardData = {
    Accommodation: Array.isArray(accommodations) ? accommodations : [],
    Events: Array.isArray(events) ? events : [],
    Restaurants: Array.isArray(restaurants) ? restaurants : [],
    Attractions: Array.isArray(attractionsites) ? attractionsites : [],
    "Shopping Malls": Array.isArray(malls) ? malls : [],
    Buses: Array.isArray(buses) ? buses : [],
  };

  const currentCategory = cardData[activeTab] || [];
  const limitedCards = currentCategory.slice(0, 3);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchAccommodations());
    dispatch(fetchEvents());
    dispatch(fetchResturants());
    dispatch(fetchAttractionsites());
    dispatch(fetchMalls());
    dispatch(fetchBuses());
  }, [dispatch]);

  const handleSeeAll = () => {
    navigate(`/see-all/${activeTab.toLowerCase()}`, {
      state: {
        category: activeTab,
        items: currentCategory,
      },
    });
  };

  return (
    <div className="category-container">
      <div className="cards-container">
        {limitedCards.map((item, index) => {
          if (!item) return null;

          // 🔥 MATCH FALLBACK IMAGES BY NAME
          const matchKey = Object.keys(fallbackImages).find(
            (key) =>
              key.toLowerCase().includes(item.name?.toLowerCase()) ||
              item.name?.toLowerCase().includes(key.toLowerCase())
          );

          const images = matchKey ? fallbackImages[matchKey] : [];

          return (
            <Card
              key={`${item.id || index}`}
              title={item.name || "Untitled"}
              description={item.description || ""}
              image={images[0] || ""}
              gallery={images} // ONLY fallback gallery
              rating={Number(item.rating) || 0}
              price={item.pricePerNight || item.price || 0}
              location={item.location || ""}
              category={item.category || ""}
              amenities={Array.isArray(item.amenities) ? item.amenities : []}
              cat={activeTab}
              phone={item.phone || ""}
              email={item.email || ""}
              name={item.name}
              ticketLink={item.ticketLink}
              mapLink={item.mapLink}
              lineUp={Array.isArray(item.lineUp) ? item.lineUp : []}
              shops={Array.isArray(item.shops) ? item.shops : []}
              routes={Array.isArray(item.routes) ? item.routes : []}
              schedule={item.schedule || []}
              operator={item.operator || ""}
              openingHours={item.openingHours || ""}
              hours={item.hours || ""}
            />
          );
        })}
      </div>

      {currentCategory.length > 3 && (
        <div className="see-all-container">
          <button className="see-all-button" onClick={handleSeeAll}>
            See All
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryCards;
